//!#system	

<template>
	<div class="my-4 mx-2">
		<v-progress-circular
			v-if="isLoading"
			indeterminate
			color="primary"
		></v-progress-circular>
		<div class="mx-2" style="font-size: 60%;" v-if="filteredActions.length > 0 && !isLoading">
			Selected: {{selected.length}}
		</div>
		<span v-for="action in filteredActions" :key="action.name">
			<v-btn
				v-if="action.isRuleButton"
				class="ma-1"
				depressed small
				:disabled="!action.isExecutable"
				@click="initiateRuleButton(action)"
			>
				{{ action.friendlyName }}
			</v-btn>
			<v-btn
				v-else
				class="ma-1"
				depressed small
				:disabled="!action.isExecutable"
				@click="runMethod('initiate_' + action.methodName, action)"
			>
				{{ action.friendlyName }}
			</v-btn>
		</span>
		<v-alert
			v-if="filteredActions.length === 0 && !isLoading"
			border="top"
			color="red lighten-2"
			dark
		>
			There are no batch features available.
		</v-alert>
		<v-dialog v-model="modals.modalAvailableTags" persistent max-width="600px" :key="modals.modalAvailableTagsKey">
			<available-tags :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeAvailableTags" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalAddToQueue" persistent max-width="600px" :key="modals.modalAddToQueueKey">
			<add-to-queue :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeAddToQueue" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalRemoveFromQueue" persistent max-width="600px" :key="modals.modalRemoveFromQueueKey">
			<remove-from-queue :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeRemoveFromQueue" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalAddTags" persistent max-width="600px" :key="modals.modalAddTagsKey">
			<add-tags :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeAddTags" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalRemoveTags" persistent max-width="600px" :key="modals.modalRemoveTagsKey">
			<remove-tags :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeRemoveTags" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalLock" persistent max-width="300px" :key="modals.modalLockKey">
			<lock :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeLock" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalDelete" persistent max-width="600px" :key="modals.modalDeleteKey">
			<delete :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeDelete" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalLinkModal" persistent max-width="600px" :key="modals.modalLinkModalKey">
			<link-modal :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeLinkModal" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalQueueTagging" persistent max-width="400px" :key="modals.modalQueueTaggingKey">
			<queue-tagging :routeInfo="routeInfo" :detail="detail" :action="currentAction" :selected="selected" @close="closeQueueTagging" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalRuleButton" persistent max-width="600px" :key="modals.modalRuleButtonKey">
			<rule-button-batch :routeInfo="routeInfo" :rule="currentRule" :detail="detail" :selected="selected" @close="closeRuleModal" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalActionButton" persistent max-width="600px" :key="modals.modalActionButtonKey">
			<modal-action :routeInfo="routeInfo" :action="currentAction" :detail="detail" :selected="selected" @close="closeActionModal" @refresh="refresh" />
		</v-dialog>
	</div>
</template>

<script>
import apiService from '@/apiService';
import tools from '@/tools';
import series from 'to-series';
import RuleButtonBatch from '@/views/modals/RuleButtonBatch';
import ModalAction from '@/views/modals/ModalAction';

import AvailableTags from '@/views/modals/AvailableTags';
import AddToQueue from '@/views/modals/AddToQueue';
import RemoveFromQueue from '@/views/modals/RemoveFromQueue';
import AddTags from '@/views/modals/AddTags';
import RemoveTags from '@/views/modals/RemoveTags';
import Lock from '@/views/modals/Lock';
import Delete from '@/views/modals/Delete';
import LinkModal from '@/views/modals/LinkModal';
import QueueTagging from '@/views/modals/QueueTagging';

export default {
	components: {
		AvailableTags,
		AddToQueue,
		RemoveFromQueue,
		AddTags,
		RemoveTags,
		Lock,
		Delete,
		LinkModal,
		QueueTagging,
		RuleButtonBatch,
		ModalAction
	},
	props: {
		routeInfo: {
			type: Object
		},
		selected: {
			type: Array,
			default: () => []
		},
		detail: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			isLoading: false,
			possibleActions: [],
			actionModals: [{"action":"setTags","ui":{"initialModal":{"componentName":"AvailableTags","componentPath":"@/views/modals/AvailableTags","componentElementName":"available-tags","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"addToQueue","ui":{"initialModal":{"componentName":"AddToQueue","componentPath":"@/views/modals/AddToQueue","componentElementName":"add-to-queue","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"removeFromQueue","ui":{"initialModal":{"componentName":"RemoveFromQueue","componentPath":"@/views/modals/RemoveFromQueue","componentElementName":"remove-from-queue","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"addTags","ui":{"initialModal":{"componentName":"AddTags","componentPath":"@/views/modals/AddTags","componentElementName":"add-tags","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"removeTags","ui":{"initialModal":{"componentName":"RemoveTags","componentPath":"@/views/modals/RemoveTags","componentElementName":"remove-tags","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"lock","ui":{"initialModal":{"componentName":"Lock","componentPath":"@/views/modals/Lock","maxWidth":"300px","componentElementName":"lock"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"archive","ui":{"initialModal":{"componentName":"Delete","componentPath":"@/views/modals/Delete","componentElementName":"delete","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"link","ui":{"initialModal":{"componentName":"LinkModal","componentPath":"@/views/modals/LinkModal","componentElementName":"link-modal","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"buckets","ui":{"initialModal":{"componentName":"QueueTagging","componentPath":"@/views/modals/QueueTagging","maxWidth":"400px","componentElementName":"queue-tagging"},"actionParams":false,"justRunActionAndRefresh":false}}],
			currentRule: {},
			currentAction: {},
			modals: {
				modalRuleButton: false,
				modalRuleButtonKey: 'mrbk' + tools.randomString(10),
				modalActionButton: false,
				modalActionButtonKey: 'mabk' + tools.randomString(10),
				modalAvailableTags: false,
				modalAvailableTagsKey: 'AvailableTags' + tools.randomString(10),
				modalAddToQueue: false,
				modalAddToQueueKey: 'AddToQueue' + tools.randomString(10),
				modalRemoveFromQueue: false,
				modalRemoveFromQueueKey: 'RemoveFromQueue' + tools.randomString(10),
				modalAddTags: false,
				modalAddTagsKey: 'AddTags' + tools.randomString(10),
				modalRemoveTags: false,
				modalRemoveTagsKey: 'RemoveTags' + tools.randomString(10),
				modalLock: false,
				modalLockKey: 'Lock' + tools.randomString(10),
				modalDelete: false,
				modalDeleteKey: 'Delete' + tools.randomString(10),
				modalLinkModal: false,
				modalLinkModalKey: 'LinkModal' + tools.randomString(10),
				modalQueueTagging: false,
				modalQueueTaggingKey: 'QueueTagging' + tools.randomString(10)
			}
		}
	},
	computed: {
		filteredActions() {
			return this.possibleActions.filter(a => a.buttonUnavailable !== true)
		}
	},
	methods: {
		getActions() {
			this.isLoading = true;
			series()
				.next(cb => {
					apiService.possibleActions({ ...this.routeInfo, context: 'batch' }, (err, response, meta) => {
						if (err) {
							this.$store.dispatch('app/applyObjectError', {
								show: true,
								text: meta.validation ? meta.validation.messages.join('\n') : err 
							});
							return cb(err);
						}
						this.possibleActions = response;
						return cb();
					});
				})
				.end(() => {
					this.isLoading = false;
				});
		},
		initiateRuleButton(action) {
			this.currentRule = { ...action };
			this.modals.modalRuleButton = true;
		},
		initiateActionButton(action) {
			this.currentAction = { ...action };
			this.modals.modalActionButton = true;
		},
		closeRuleModal() {
			this.modals.modalRuleButton = false;
			this.modals.modalRuleButtonKey = 'crm' + tools.randomString(10);
		},
		closeActionModal() {
			this.modals.modalActionButton = false;
			this.modals.modalActionButtonKey = 'cam' + tools.randomString(10);
		},
		runMethod(name, action) {
			if(typeof this[name] === 'function') {
				this[name](action);
			}
		},
		refresh() {
			this.$emit('refresh');
		}
		,openAvailableTags() {
			this.modals.modalAvailableTags = true;
		}
		,closeAvailableTags() {
			this.modals.modalAvailableTagsKey = this.rotatingKey + '-AvailableTags';
			this.modals.modalAvailableTags = false;
		}
		,openAddToQueue() {
			this.modals.modalAddToQueue = true;
		}
		,closeAddToQueue() {
			this.modals.modalAddToQueueKey = this.rotatingKey + '-AddToQueue';
			this.modals.modalAddToQueue = false;
		}
		,openRemoveFromQueue() {
			this.modals.modalRemoveFromQueue = true;
		}
		,closeRemoveFromQueue() {
			this.modals.modalRemoveFromQueueKey = this.rotatingKey + '-RemoveFromQueue';
			this.modals.modalRemoveFromQueue = false;
		}
		,openAddTags() {
			this.modals.modalAddTags = true;
		}
		,closeAddTags() {
			this.modals.modalAddTagsKey = this.rotatingKey + '-AddTags';
			this.modals.modalAddTags = false;
		}
		,openRemoveTags() {
			this.modals.modalRemoveTags = true;
		}
		,closeRemoveTags() {
			this.modals.modalRemoveTagsKey = this.rotatingKey + '-RemoveTags';
			this.modals.modalRemoveTags = false;
		}
		,openLock() {
			this.modals.modalLock = true;
		}
		,closeLock() {
			this.modals.modalLockKey = this.rotatingKey + '-Lock';
			this.modals.modalLock = false;
		}
		,openDelete() {
			this.modals.modalDelete = true;
		}
		,closeDelete() {
			this.modals.modalDeleteKey = this.rotatingKey + '-Delete';
			this.modals.modalDelete = false;
		}
		,openLinkModal() {
			this.modals.modalLinkModal = true;
		}
		,closeLinkModal() {
			this.modals.modalLinkModalKey = this.rotatingKey + '-LinkModal';
			this.modals.modalLinkModal = false;
		}
		,openQueueTagging() {
			this.modals.modalQueueTagging = true;
		}
		,closeQueueTagging() {
			this.modals.modalQueueTaggingKey = this.rotatingKey + '-QueueTagging';
			this.modals.modalQueueTagging = false;
		}
		,initiate_setTags(action) {
			this.currentAction = { ...action };
			this.openAvailableTags();
		}
		,initiate_addToQueue(action) {
			this.currentAction = { ...action };
			this.openAddToQueue();
		}
		,initiate_removeFromQueue(action) {
			this.currentAction = { ...action };
			this.openRemoveFromQueue();
		}
		,initiate_addTags(action) {
			this.currentAction = { ...action };
			this.openAddTags();
		}
		,initiate_removeTags(action) {
			this.currentAction = { ...action };
			this.openRemoveTags();
		}
		,initiate_aggregateQueues(action) {
		}
		,initiate_lock(action) {
			this.currentAction = { ...action };
			this.openLock();
		}
		,initiate_archive(action) {
			this.currentAction = { ...action };
			this.openDelete();
		}
		,initiate_link(action) {
			this.currentAction = { ...action };
			this.openLinkModal();
		}
		,initiate_getLinks(action) {
		}
		,initiate_removeLink(action) {
		}
		,initiate_checkGate(action) {
		}
		,initiate_removeGate(action) {
		}
		,initiate_getCopyJson(action) {
		}
		,initiate_getDeletedItems(action) {
		}
		,initiate_buckets(action) {
			this.currentAction = { ...action };
			this.openQueueTagging();
		}
	},
	created() {
		this.getActions();
	}
}
</script>

<style>
</style>